import {
	CATEGORIES_SETTINGS_ADD_CATEGORIES
} from "../constants";

const initialState = {
	data: []
};

export const CategoriesReducer = ( state = initialState, action ) => {
	switch ( action.type ) {
        case CATEGORIES_SETTINGS_ADD_CATEGORIES :
			state = {
				...state,
				data: action.payload.data.categories
			};

			break;
	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/categories.js